import IconButton from '@/shared/components/IconButton/IconButton'
import { useRef } from 'react'
import { useClickOutsideWithExceptions } from '@/shared/hooks/useClickOutsideWithExceptions'
import styles from './OptionsTile.module.scss'

interface OptionsTileProps {
  onEditClick?: () => void
  onDeleteClick?: () => void
  onClose: () => void
}

function OptionsTile(props: OptionsTileProps) {
  const { onEditClick, onDeleteClick, onClose } = props
  const optionTileRef = useRef<HTMLDivElement>(null)
  useClickOutsideWithExceptions({
    refs: [optionTileRef],
    onClickOutside: onClose
  })

  /*
    Both actions close the tile after running.

    It already closed on a click outside, but not on a click on its own buttons,
    so choosing edit left the trash and pencil sitting over the thing being
    edited. Closing here rather than in each caller keeps the two ways out of
    this tile in one place.
  */
  const handleOnEditClick = () => {
    onEditClick?.()
    onClose()
  }

  const handleOnDeleteClick = () => {
    onDeleteClick?.()
    onClose()
  }

  return (
    <div className={styles.OptionsTileWrapper} ref={optionTileRef}>
      {onDeleteClick && (
        <IconButton
          icon="las la-trash icon-small"
          onClick={handleOnDeleteClick}
          color="primary"
        />
      )}
      <IconButton
        icon="las la-pen icon-small"
        onClick={handleOnEditClick}
        color="primary"
      />
    </div>
  )
}
export default OptionsTile
